<div class="row paymentContainer mt-3">

    <div class="selected-class-title"> {{ 'PaymentNeededMsg' | translate }}:</div>

  <div class="col-md-12 p-0">
    <!--Payment Type-->


    <!-- <p>{{ 'RequiredPaymentIs' | translate }} : <span class="text-blue">{{requiredPayment | number : '1.2-2'}}
        {{currency}}</span></p>
 -->
    <mat-radio-group  [(ngModel)]="depositeType" *ngIf="objPayment!=null">
      <ng-container *ngFor="let item of objPayment.depositPolicyPaymentTypes">
        <div [ngSwitch]="item">
          <div *ngSwitchCase="DepositPolicyPaymentTypes.FullPaymentIsRequired">
            <mat-radio-button class="mr-3" [value]="DepositPolicyPaymentTypes.FullPaymentIsRequired"
            [checked]="depositeType==DepositPolicyPaymentTypes.FullPaymentIsRequired"
            >
              {{ 'FullAmount' | translate }} [{{objPayment.fullPayment| number : '1.2-2'}} {{currency}}]
            </mat-radio-button>
          </div>
          <div *ngSwitchCase="DepositPolicyPaymentTypes.PercentageOfTotalCharges">

            <mat-radio-button [value]="DepositPolicyPaymentTypes.PercentageOfTotalCharges"
            [checked]="depositeType==DepositPolicyPaymentTypes.PercentageOfTotalCharges"
            >
              {{ 'MinimumDeposit' | translate }} [{{objPayment.minDeposit | number : '1.2-2'}} {{currency}}]
            </mat-radio-button>
          </div>
          <div *ngSwitchCase="DepositPolicyPaymentTypes.NoPaymentIsRequired">

            <mat-radio-button [value]="DepositPolicyPaymentTypes.NoPaymentIsRequired"
            [checked]="depositeType==DepositPolicyPaymentTypes.NoPaymentIsRequired"
            >
              {{ 'NoPaymentsIsRequired' | translate }}
            </mat-radio-button>
          </div>
        </div>
      </ng-container>
    </mat-radio-group>




    <payment-shared [rentalServiceDeliveryChannel]="RentalServiceDeliveryChannel.Online" [caseID]="vehicleReservationCaseResult.caseID" [depositeType]="depositeType" [paymentMode]="PaymentMode.Edit"></payment-shared>

    <div class="booking-steps">
      <button mat-button (click)="cancelClicked()">
        <fa-icon class="mr-2" [icon]="faChevronCircleLeft"></fa-icon> <span class="mt-1">{{ 'Back' | translate }}</span>
      </button>
    </div>


    <!-- <form [formGroup]="paymentForm" (ngSubmit)="onSubmit()">
    </form> -->
  </div>










</div>
